// src/pages/Dashboard/components/CasePanel/JurisprudenceSection/JurisprudenceSection.js

import React, { useState } from 'react';
import JurisprudenceTable from './JurisprudenceTable';
import { prepararConteudoJurisprudencias } from '../../../utils/clientDataProcessor';
import './JurisprudenceSection.css';

/**
 * Seção de jurisprudências relacionadas ao caso
 * @param {Array} jurisprudencias - Lista de jurisprudências
 * @param {boolean} loading - Se está carregando
 * @param {function} onViewDetails - Callback para ver detalhes
 * @param {function} onRemove - Callback para remover
 */
const JurisprudenceSection = ({ 
  jurisprudencias, 
  loading, 
  onViewDetails, 
  onRemove 
}) => {
  const [expanded, setExpanded] = useState(false);

  const handleCopy = async () => {
    try {
      const conteudo = prepararConteudoJurisprudencias(jurisprudencias);
      await navigator.clipboard.writeText(conteudo);
      alert('Conteúdo copiado!');
    } catch (error) {
      console.error('Erro ao copiar:', error);
      alert('Erro ao copiar conteúdo');
    }
  };

  return (
    <div className="secao-jurisprudencia-dashboard">
      <h3>Jurisprudência Relacionada</h3>
      
      <div className="jurisprudencia-item">
        <div 
          className="jurisprudencia-header" 
          onClick={() => setExpanded(!expanded)}
        >
          <span>
            Jurisprudências Relacionadas 
            {jurisprudencias.length > 0 && (
              <span style={{ color: '#28a745', marginLeft: '8px' }}>
                ({jurisprudencias.length})
              </span>
            )}
          </span>
          <div className="jurisprudencia-actions">
            <button 
              className="btn-copy" 
              onClick={(e) => { 
                e.stopPropagation(); 
                handleCopy(); 
              }}
              title="Copiar conteúdo"
            >
              📋
            </button>
            <span className={`arrow ${expanded ? 'expanded' : ''}`}>▼</span>
          </div>
        </div>
        
        {expanded && (
          <div className="jurisprudencia-content">
            {loading ? (
              <div className="loading-jurisprudencias">Carregando jurisprudências...</div>
            ) : jurisprudencias.length === 0 ? (
              <div className="no-jurisprudencias">
                <p>Nenhuma jurisprudência associada a este caso.</p>
                <small>Use a seção "Pesquisa de Jurisprudência" para encontrar e associar jurisprudências relevantes.</small>
              </div>
            ) : (
              <JurisprudenceTable
                jurisprudencias={jurisprudencias}
                onViewDetails={onViewDetails}
                onRemove={onRemove}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default JurisprudenceSection;